import * as React from 'react';
import * as MarkdownMain from 'markdown-it';
import * as MarkdownSub from 'markdown-it-sub';
import * as MarkdownSup from 'markdown-it-sup';
import * as MarkdownUnderline from 'markdown-it-underline';
import * as MarkdownContainer from 'markdown-it-container';
import * as MarkdownLinkAttributes from 'markdown-it-link-attributes';
import './styles.sass';

const md = new (MarkdownMain as any)({typographer: true, breaks: true})
  .use(MarkdownLinkAttributes, {
    attrs: {target: '_blank'},
  })
  .use(MarkdownContainer, 'variable')
  .use(MarkdownUnderline)
  .use(MarkdownSub)
  .use(MarkdownSup);

interface IMarkdownProps {
  children: any;
}

export const Markdown: React.StatelessComponent<IMarkdownProps> = ({children}) => (
  <div
    className={'markdown'}
    dangerouslySetInnerHTML={{__html: md.render(children)}}
  />
);
